<template>
	<c-dialog ref="saveResumeDialog" :visible="open" class="cog-save-resume-dialog" v-on="$listeners">
		<c-row slot="title">
			<div class="cog-content cog-col cog-col--24">
				<h2 class="cog-heading">{{ $resource('save-and-resume-message') }}</h2>
				<p>{{ saveMessage }}</p>
			</div>
		</c-row>
		<c-row>
			<c-field field-id="cog-save-resume-link" :label="$resource('save-and-resume-copy-link-label')">
				<c-input id="cog-save-resume-link" :value="link" @click.native="$event.target.select()" />
			</c-field>
		</c-row>

		<c-row>
			<c-field :field-id="_uid + '-email'" :label="$resource('save-and-resume-email-label')">
				<c-row>
					<c-input :id="_uid + '-email'" type="email" class="cog-input--long" :value="email" :readonly="requireAuthentication" @input="handleEmailInput" @change="handleEmailChange" />
					<div class="cog-input">
						<c-status-button :disabled="!email || !enableSend" :status="emailStatus" :duration="4000" class="cog-save-resume__button cog-button--primary" @click.native="sendEmail">{{ $resource('send-button-text') }}</c-status-button>
					</div>
					<transition name="cog-error-message">
						<div v-if="emailError && showEmailError" class="cog-error-message cog-error-message--container-footer" style="margin: 0 7px;">{{ emailError }}</div>
					</transition>
				</c-row>
			</c-field>
		</c-row>
	</c-dialog>
</template>

<script>
	import CDialog from './Dialog.vue';
	import CField from './FieldNoSource.vue';
	import CInput from './Input.vue';
	import CStatusButton from './StatusButton.vue';
	import { FormStatusProp } from 'src/mixins/form-status';
	import { formatAddresses, reformatEmail } from 'src/util/email';

	// Taken from output based on fields in `DynamicEntityTypeProvider`
	// TODO: Is there a better way to handle this?
	const emailDescription = 'name@domain.com';
	// eslint-disable-next-line no-useless-escape

	const emailMessage = 'Email must be formatted as name@domain.com.';

	export default {
		name: 'CSaveResumeDialog',
		components: { CDialog, CInput, CStatusButton, CField },
		inject: ['$resource'],
		props: {
			open: Boolean,
			link: { type: String, required: true },
			emailAddress: { type: String, default: null },
			emailStatus: FormStatusProp,
			enableSend: { type: Boolean, default: true },
			message: { type: String, default: '' },
			requireAuthentication: { type: Boolean, default: false }
		},
		data() {
			return {
				email: this.emailAddress,
				emailError: '',
				showEmailError: false
			};
		},
		computed: {
			saveMessage() {
				return this.message ? this.message : this.$resource('save-and-resume-no-expiration-message');
			}
		},
		watch: {
			emailAddress(val) {
				this.email = val;
			}

		},
		methods: {
			handleEmailInput(text) {
				// Store the new email value
				this.email = text;
			},
			handleEmailChange(text) {
				// Store the new email value
				this.email = text;
				// Check whether the email is valid
				if (this.isValidEmail()) {
					// Reformat the email if it is valid
					this.email = reformatEmail(text);
				}
			},
			sendEmail() {
				// Begin showing the error once the user clicks "Send"
				this.showEmailError = true;
				// If the email is valid, then raise the event
				if (this.isValidEmail()) {
					this.$emit('send-email', this.email);
				}
			},
			isValidEmail() {
				const formattedEmails = formatAddresses(this.email);

				// If there is no email, then mark it as required
				if (!this.email) {
					this.emailError = this.$resource('required', { property: 'Email' });
					return false;
				}
				// If the email is improperly formatted, then show a format error
				else if (!formattedEmails) {
					this.emailError = this.$resource('string-format', { property: 'Email', formatDescription: emailDescription }) || emailMessage;
					return false;
				}
				// Valid
				else {
					this.emailError = '';
					return true;
				}
			}
		}
	};
</script>

<style lang="scss">
#{$specificity-base} {
	// Get button vertically centered with email input.
	// Using a more traditional method like align-items: center on the row would work, but
	// the button (if bigger), would push the email input away from the label. With very big buttons, this looks dumb.
	.cog-cognito--styled .cog-save-resume__button {
		margin-top: calc((var(--button-primary__font-size) - var(--input__font-size, 1em)) * -.5);
	}

	&.cog-iframe-embed .cog-save-resume-dialog .el-dialog {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
	}
}
</style>